import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MenuIcon from '@mui/icons-material/Menu';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Slide from '@mui/material/Slide';
import Toolbar from '@mui/material/Toolbar';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import PropTypes from 'prop-types';
import { useState } from 'react';
import izicare_logo from '../../../../static/izicare_logo.svg';

function HideOnScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
  });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children ?? <div />}
    </Slide>
  );
}

HideOnScroll.propTypes = {
  children: PropTypes.element,
  window: PropTypes.func,
};

const MAX_WIDTH = '1360px';

export default function NavbarFrontaliere() {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const isProd = process.env.REACT_APP_ENVIRONMENT === 'production';

  // Menu Mon Espace
  const menuItems = [
    {
      label: 'Espace Assuré',
      href: isProd
        ? 'https://assure.izicare.com'
        : '/login?cat=particulier',
      svg: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.2366 14.9062C15.1657 13.0549 13.5155 11.7274 11.5896 11.0981C12.5422 10.531 13.2824 9.66686 13.6963 8.63841C14.1103 7.60996 14.1752 6.47405 13.8811 5.40513C13.5871 4.33621 12.9502 3.39338 12.0684 2.72142C11.1866 2.04947 10.1086 1.68555 9.00001 1.68555C7.89137 1.68555 6.81338 2.04947 5.93159 2.72142C5.0498 3.39338 4.41296 4.33621 4.11887 5.40513C3.82479 6.47405 3.88971 7.60996 4.30369 8.63841C4.71766 9.66686 5.45778 10.531 6.4104 11.0981C4.48454 11.7267 2.8343 13.0542 1.76344 14.9062C1.72417 14.9702 1.69813 15.0415 1.68684 15.1158C1.67555 15.19 1.67925 15.2658 1.69772 15.3386C1.71619 15.4114 1.74905 15.4798 1.79438 15.5397C1.8397 15.5996 1.89656 15.6498 1.9616 15.6874C2.02665 15.7249 2.09856 15.7491 2.17309 15.7584C2.24762 15.7678 2.32327 15.7621 2.39557 15.7417C2.46787 15.7213 2.53535 15.6867 2.59404 15.6398C2.65273 15.5929 2.70143 15.5347 2.73727 15.4687C4.06196 13.1793 6.40337 11.8125 9.00001 11.8125C11.5966 11.8125 13.9381 13.1793 15.2627 15.4687C15.2986 15.5347 15.3473 15.5929 15.406 15.6398C15.4647 15.6867 15.5321 15.7213 15.6044 15.7417C15.6767 15.7621 15.7524 15.7678 15.8269 15.7584C15.9015 15.7491 15.9734 15.7249 16.0384 15.6874C16.1035 15.6498 16.1603 15.5996 16.2056 15.5397C16.251 15.4798 16.2838 15.4114 16.3023 15.3386C16.3208 15.2658 16.3245 15.19 16.3132 15.1158C16.3019 15.0415 16.2758 14.9702 16.2366 14.9062ZM5.06251 6.74996C5.06251 5.9712 5.29344 5.20992 5.7261 4.5624C6.15875 3.91488 6.77371 3.4102 7.49319 3.11218C8.21268 2.81416 9.00438 2.73619 9.76818 2.88812C10.532 3.04005 11.2336 3.41506 11.7842 3.96573C12.3349 4.5164 12.7099 5.21799 12.8618 5.98179C13.0138 6.74559 12.9358 7.53729 12.6378 8.25678C12.3398 8.97626 11.8351 9.59121 11.1876 10.0239C10.54 10.4565 9.77877 10.6875 9.00001 10.6875C7.95606 10.6863 6.95519 10.2711 6.21701 9.53296C5.47883 8.79478 5.06362 7.79391 5.06251 6.74996Z"
            fill="#424445"
          ></path>
        </svg>
      ),
    },
    {
      label: 'Espace Employeur',
      href: isProd
        ? 'https://employeur.izicare.com'
        : '/login?cat=professionnel',
      svg: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.4375 14.625H16.3125V6.75C16.4617 6.75 16.6048 6.69074 16.7102 6.58525C16.8157 6.47976 16.875 6.33668 16.875 6.1875C16.875 6.03832 16.8157 5.89524 16.7102 5.78975C16.6048 5.68426 16.4617 5.625 16.3125 5.625H12.9375V3.375C13.0867 3.375 13.2298 3.31574 13.3352 3.21025C13.4407 3.10476 13.5 2.96168 13.5 2.8125C13.5 2.66332 13.4407 2.52024 13.3352 2.41475C13.2298 2.30926 13.0867 2.25 12.9375 2.25H2.8125C2.66332 2.25 2.52024 2.30926 2.41475 2.41475C2.30926 2.52024 2.25 2.66332 2.25 2.8125C2.25 2.96168 2.30926 3.10476 2.41475 3.21025C2.52024 3.31574 2.66332 3.375 2.8125 3.375V14.625H1.6875C1.53832 14.625 1.39524 14.6843 1.28975 14.7898C1.18426 14.8952 1.125 15.0383 1.125 15.1875C1.125 15.3367 1.18426 15.4798 1.28975 15.5852C1.39524 15.6907 1.53832 15.75 1.6875 15.75H17.4375C17.5867 15.75 17.7298 15.6907 17.8352 15.5852C17.9407 15.4798 18 15.3367 18 15.1875C18 15.0383 17.9407 14.8952 17.8352 14.7898C17.7298 14.6843 17.5867 14.625 17.4375 14.625ZM15.1875 6.75V14.625H12.9375V6.75H15.1875ZM3.9375 3.375H11.8125V14.625H10.125V11.25C10.125 11.1008 10.0657 10.9577 9.96025 10.8523C9.85476 10.7468 9.71168 10.6875 9.5625 10.6875H6.1875C6.03832 10.6875 5.89524 10.7468 5.78975 10.8523C5.68426 10.9577 5.625 11.1008 5.625 11.25V14.625H3.9375V3.375ZM9 14.625H6.75V11.8125H9V14.625ZM5.0625 5.625C5.0625 5.47582 5.12176 5.33274 5.22725 5.22725C5.33274 5.12176 5.47582 5.0625 5.625 5.0625H6.75C6.89918 5.0625 7.04226 5.12176 7.14775 5.22725C7.25324 5.33274 7.3125 5.47582 7.3125 5.625C7.3125 5.77418 7.25324 5.91726 7.14775 6.02275C7.04226 6.12824 6.89918 6.1875 6.75 6.1875H5.625C5.47582 6.1875 5.33274 6.12824 5.22725 6.02275C5.12176 5.91726 5.0625 5.77418 5.0625 5.625ZM8.4375 5.625C8.4375 5.47582 8.49676 5.33274 8.60225 5.22725C8.70774 5.12176 8.85082 5.0625 9 5.0625H10.125C10.2742 5.0625 10.4173 5.12176 10.5227 5.22725C10.6282 5.33274 10.6875 5.47582 10.6875 5.625C10.6875 5.77418 10.6282 5.91726 10.5227 6.02275C10.4173 6.12824 10.2742 6.1875 10.125 6.1875H9C8.85082 6.1875 8.70774 6.12824 8.60225 6.02275C8.49676 5.91726 8.4375 5.77418 8.4375 5.625ZM5.0625 8.4375C5.0625 8.28832 5.12176 8.14524 5.22725 8.03975C5.33274 7.93426 5.47582 7.875 5.625 7.875H6.75C6.89918 7.875 7.04226 7.93426 7.14775 8.03975C7.25324 8.14524 7.3125 8.28832 7.3125 8.4375C7.3125 8.58668 7.25324 8.72976 7.14775 8.83525C7.04226 8.94074 6.89918 9 6.75 9H5.625C5.47582 9 5.33274 8.94074 5.22725 8.83525C5.12176 8.72976 5.0625 8.58668 5.0625 8.4375ZM8.4375 8.4375C8.4375 8.28832 8.49676 8.14524 8.60225 8.03975C8.70774 7.93426 8.85082 7.875 9 7.875H10.125C10.2742 7.875 10.4173 7.93426 10.5227 8.03975C10.6282 8.14524 10.6875 8.28832 10.6875 8.4375C10.6875 8.58668 10.6282 8.72976 10.5227 8.83525C10.4173 8.94074 10.2742 9 10.125 9H9C8.85082 9 8.70774 8.94074 8.60225 8.83525C8.49676 8.72976 8.4375 8.58668 8.4375 8.4375Z"
            fill="#424445"
          ></path>
        </svg>
      ),
    },
    {
      label: 'Espace Partenaire',
      href: isProd
        ? 'https://partenaire.izicare.com'
        : 'https://juno.demo.to.day',
      svg: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.1875 4.5H12.375C12.375 3.60489 12.0194 2.74645 11.3865 2.11351C10.7536 1.48058 9.89511 1.125 9 1.125C8.10489 1.125 7.24645 1.48058 6.61351 2.11351C5.98058 2.74645 5.625 3.60489 5.625 4.5H2.8125C2.51413 4.5 2.22798 4.61853 2.017 4.8295C1.80603 5.04048 1.6875 5.32663 1.6875 5.625V14.0625C1.6875 14.3609 1.80603 14.647 2.017 14.858C2.22798 15.069 2.51413 15.1875 2.8125 15.1875H15.1875C15.4859 15.1875 15.772 15.069 15.983 14.858C16.194 14.647 16.3125 14.3609 16.3125 14.0625V5.625C16.3125 5.32663 16.194 5.04048 15.983 4.8295C15.772 4.61853 15.4859 4.5 15.1875 4.5ZM9 2.25C9.59674 2.25 10.169 2.48705 10.591 2.90901C11.0129 3.33097 11.25 3.90326 11.25 4.5H6.75C6.75 3.90326 6.98705 3.33097 7.40901 2.90901C7.83097 2.48705 8.40326 2.25 9 2.25ZM15.1875 14.0625H2.8125V5.625H15.1875V14.0625Z"
            fill="#424445"
          ></path>
        </svg>
      ),
    },
  ];

  // Desktop menu links
  const menuLinks = [
    { label: 'Offre Employeur', href: '/contrats-collectifs' },
    { label: 'Offre Individuelle', href: '/contrats-individuels' },
    { label: 'Choix CMU vs LAMal', href: '/cmu-vs-lamal' },
    { label: 'Guide du frontalier', href: '/blog' },
    { label: 'A propos', href: '/qui-sommes-nous' },
  ];

  const secondmenuLinks = [
    { label: 'FAQ', href: '/faq' },
    { label: 'Contact', href: '/contact' },
  ];

  // Mobile drawer menu
  const mobileMenuLinks = [...menuLinks, ...secondmenuLinks];

  return (
    <>
      <HideOnScroll>
        <AppBar
          elevation={0}
          sx={{
            backgroundColor: '#FFEFE8',
            justifyContent: 'center',
            px: { xs: 2, md: 6 },
            height: '88px',
          }}
        >
          <Toolbar
            disableGutters
            sx={{
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
            }}
          >
            <Box
              sx={{
                width: '100%',
                maxWidth: MAX_WIDTH,
                display: 'flex',
                alignItems: 'center',
                px: 2,
              }}
            >
              <Box
                component="img"
                src={izicare_logo}
                alt="Logo"
                sx={{ height: '24.14px' }}
              />

              <Box
                sx={{
                  display: { xs: 'none', md: 'flex' },
                  gap: '30px',
                  alignItems: 'center',
                  width: '100%',
                  pl: 7.5,
                }}
              >
                {menuLinks.map((link) => (
                  <Link
                    key={link.label}
                    underline="none"
                    href={process.env.REACT_APP_URL + link.href}
                    sx={{
                      fontFamily: 'JakartaSansMedium !important',
                      color: '#4F0A14',
                      textTransform: 'none',
                      fontSize: '14px',
                    }}
                  >
                    {link.label}
                  </Link>
                ))}

                <Box sx={{ flexGrow: 1 }} />

                {secondmenuLinks.map((link) => (
                  <Link
                    key={link.label}
                    underline="none"
                    href={process.env.REACT_APP_URL + link.href}
                    sx={{
                      color: '#4F0A14',
                      textTransform: 'none',
                      fontSize: '14px !important',
                    }}
                  >
                    {link.label}
                  </Link>
                ))}

                <Button
                  variant="contained"
                  onClick={handleOpen}
                  endIcon={<KeyboardArrowDownIcon />}
                  sx={{
                    backgroundColor: 'button.main',
                    gap: 1,
                    fontSize: '16px',
                    fontFamily: 'JakartaSansMedium !important',
                    p: '10px 18px',
                    minWidth: '173px',
                  }}
                >
                  Se connecter
                </Button>

                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  sx={{
                    mt: 1,
                    '& .MuiList-root': {
                      backgroundColor: 'white',
                      borderRadius: '8px',
                    },
                  }}
                >
                  {menuItems.map((item) => (
                    <MenuItem
                      key={item.label}
                      component="a"
                      href={item.href}
                      onClick={handleClose}
                      sx={{ gap: 1, fontSize: '14px' }}
                    >
                      {item.svg} {item.label}
                    </MenuItem>
                  ))}
                </Menu>
              </Box>

              <IconButton
                color="primary"
                sx={{
                  display: { xs: 'flex', md: 'none' },
                  ml: 'auto',
                }}
                onClick={() => setOpen(true)}
              >
                <MenuIcon />
              </IconButton>
            </Box>
          </Toolbar>
        </AppBar>
      </HideOnScroll>

      <Drawer
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
      >
        <Box
          sx={{
            width: '100vw',
            height: '100vh',
            position: 'relative',
            backgroundColor: 'white',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              my: 3,
              px: 2,
            }}
          >
            <Box
              component="img"
              src={izicare_logo}
              alt="Logo"
              sx={{ height: '27px', ml: 2 }}
            />
            <Box sx={{ flexGrow: 1 }} />
            <IconButton
              color="primary"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Divider />

          <List sx={{ mt: 0, px: 2 }}>
            {mobileMenuLinks.map((link) => (
              <ListItem key={link.label} disablePadding>
                <ListItemButton
                  component="a"
                  href={process.env.REACT_APP_URL + link.href}
                >
                  <ListItemText
                    primary={link.label}
                    sx={{
                      fontFamily: 'JakartaSansMedium !important',
                      color: '#4F0A14',
                      textTransform: 'none',
                      fontSize: '14px',
                    }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              width: '100%',
              px: 2,
              pt: 2,
            }}
          >
            {menuItems.map((item) => (
              <Button
                key={item.label}
                variant="contained"
                component="a"
                href={item.href}
                sx={{
                  bgcolor: 'button.main',
                  width: '100%',
                  height: '45px',
                  textTransform: 'none',
                  fontFamily: 'JakartaSansMedium !important',
                }}
              >
                {item.label}
              </Button>
            ))}
          </Box>
        </Box>
      </Drawer>
    </>
  );
}
